import React from "react";
import { periodTypes, statusTypes, useMatchData } from "../../../mls-match-list/utils";
import { useReactAppState } from "../../containers/utils";
import StatusLiveStamp from "./StatusLiveStamp/StatusLiveStamp";
import { StyledStatusStamp, StyledStatusStampDot } from "./StyledStatusStamp";
import { StyledStatusLiveStamp } from "./StatusLiveStamp/StyledStatusLiveStamp";

const StatusStamp = ({
  abbreviation = null,
  time = null,
  minuteDisplay = null,
  extraMinutes = null,
  showLiveDot = false,
  abbreviateStatus = false,
  abbreviatePostMatch = false,
}) => {
  const { status, penaltyKicks } = useMatchData();
  const { t } = useReactAppState();

  if (!abbreviation) {
    return null;
  }

  const transformAbbreviationLabel = (key) => {
    const label = t(key);

    if (abbreviateStatus) {
      return label.toUpperCase();
    }

    return label;
  };

  const label = () => {
    if (status?.period === periodTypes.half) {
      return <StyledStatusLiveStamp>HT</StyledStatusLiveStamp>;
    }

    switch (abbreviation) {
      case statusTypes.post:
        return abbreviatePostMatch ? t("match_final.abbr") : t("match_final");
      case statusTypes.postponed:
        return transformAbbreviationLabel(
          abbreviateStatus ? "match_postponed.abbr" : "match_postponed"
        );
      case statusTypes.abandoned:
        return transformAbbreviationLabel(
          abbreviateStatus ? "match_abandoned.abbr" : "match_abandoned"
        );
      case statusTypes.cancelled:
        return transformAbbreviationLabel(
          abbreviateStatus ? "match_cancelled.abbr" : "match_cancelled"
        );
      case statusTypes.delayed:
        return transformAbbreviationLabel(
          abbreviateStatus ? "match_delayed.abbr" : "match_delayed"
        );
      case statusTypes.pre:
        return time;
      case statusTypes.live: {
        const hasPenaltyKicks = penaltyKicks?.home && penaltyKicks?.away;
        return showLiveDot ? (
          <StyledStatusStampDot />
        ) : (
          <StatusLiveStamp
            minuteDisplay={minuteDisplay}
            extraMinutes={extraMinutes}
            hasPenaltyKicks={hasPenaltyKicks}
          />
        );
      }
      case statusTypes.finalWhistle:
        return transformAbbreviationLabel(
          abbreviateStatus ? "match_final.abbr" : "match_final"
        );
      default:
        return null;
    }
  };

  return (
    <StyledStatusStamp
      className={`mls-c-status-stamp__status ${abbreviation ? `-${abbreviation}` : ""
        }`}
    >
      {label()}
    </StyledStatusStamp>
  );
};

export default StatusStamp;
